<template>
  <div class="box-head-navbar">
    <div class="flex01">
      <div class="box-indent-leftmenu" @click="clkToggleLeftMenu">
        <i :class="['iconfont',leftMenuStatus=='open'?'icon-indent-right':'icon-indent-left']"></i>
      </div>
      <div class="box-sitename" v-html="appName"></div>
    </div>
    <div class="flex02">

      <div class="box-username">
        <el-button type="text" v-html="userInfo.realname"></el-button>
      </div>
      <div class="box-useravator">
        <el-dropdown>
          <div class="el-dropdown-link">
            <el-avatar size="small" shape="circle" :src="userInfo.avatar_url"></el-avatar>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown" class="dropmenu-avator" size="small">
            <el-dropdown-item @click.native="clkToIndex"><span>大屏端</span></el-dropdown-item>
            <el-dropdown-item @click.native="clkMyProfile"><span>个人简介</span></el-dropdown-item>
            <el-dropdown-item @click.native="clkLogout">注销</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    name: 'HeadNavbar',
    data() {
      return {
        appName: this.settings.appName,
        messageCount: 12
      };
    },
    computed: {
      leftMenuStatus() {
        return this.$store.state.leftMenuStatus;
      },
      userInfo(){
        return this.$store.state.loginUserInfo;
      }
    },
    watch: {
    },
    methods: {
      clkToggleLeftMenu() {
        this.$store.commit('doToggleLeftMenu');
      },
      clkLogout() {
        this.$confirm('您确信要注销吗？')
          .then(() => {
            this.$store.commit('clearLoginUserInfo');
          })
          .catch(() => {});
      },
      clkToIndex(){
        this.$router.push('/datavisual/index')
      }

    }
  };
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/param.scss";

  .box-head-navbar {
    height: $navbarHeight;
    background-color: $bgHeadNavbar;
    display: flex;

    .flex01 {
      flex: 1;
      display: flex;

      .box-sitename {
        line-height: $navbarHeight;
        font-size: 14px;
      }

    }

    .flex02 {
      padding-right: 20px;
      flex: 1;
      display: flex;
      justify-content: flex-end;

      .box-change-locale-lang {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .box-notify {
        display: flex;
        padding: 10px;
        align-items: center;

        .iconfont {
          font-size: 26px;
          color: #bfcbd9;
        }
      }

      .box-useravator {
        padding-left: 5px;
        display: flex;
        align-items: center;
      }
    }

    .box-indent-leftmenu {
      padding-left: 16px;
      padding-right: 16px;
      line-height: $navbarHeight;
      cursor: pointer;

      .iconfont {
        font-size: 22px;
        color: #333333;
      }
    }
  }

  .dropmenu-avator {

  }
</style>



// WEBPACK FOOTER //
// src/views/layout/admin/HeadNavbar.vue